import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { usePopupStore, useTenantInMarketStore } from "../..";
import useNavigateToTenantInMarket from "../../hooks/useNavigateToTenantInMarket";
import { usePopupShapesOnMap } from "../../hooks/useShapesOnMap";
import GeometryService from "../../services/geometryService";
import { formatDateTime, formatNumber } from "../../utils/utils";
import commonStyles from "../Common.module.css";
import FieldRow from "../FieldRow";
import TenantInMarketIcon from "../icons/TenantInMarketIcon";
import MapPopupWithFitBounds from "../MapPopupWithFitBounds";
import popupStyles from "../Popup.module.css";

function TenantInMarketPopup({ id }: ITenantInMarketPopupProps) {
    const navigateToTenantInMarket = useNavigateToTenantInMarket();
    const tenantInMarketStore = useTenantInMarketStore();
    const popupStore = usePopupStore();
    const geometryService = useMemo(() => new GeometryService(), []);
    const tenantInMarket = useMemo(() => computed(() => tenantInMarketStore.tenantsInMarket.find(tim => tim.id === id)), [id]).get();
    const centerPoint = useMemo(() => tenantInMarket && geometryService.getShapeCenterPoint(tenantInMarket.shape), [tenantInMarket]);
    usePopupShapesOnMap(tenantInMarket && [tenantInMarket.shape], "TenantInMarketShape");

    if (tenantInMarketStore.isTenantsInMarketLoading.fetching)
        return null;

    if (!tenantInMarket)
        return null;

    return (
        <MapPopupWithFitBounds
            longitude={centerPoint!.lng}
            latitude={centerPoint!.lat}
            shape={tenantInMarket.shape}
            closeButton={true}
            closeOnClick={false}
            onClose={() => popupStore.close()}
            anchor="bottom"
        >
            <div className={popupStyles.header}>
                <TenantInMarketIcon color="white" />
                <div className={popupStyles.titleClickable} onClick={() => navigateToTenantInMarket(id, true)}>
                    <div>{tenantInMarket.description}</div>
                </div>
            </div>
            <div className={popupStyles.table}>
                <div className={popupStyles.tableItem}>
                    <div>Land Area Needed</div>
                    <div>{!!tenantInMarket.landAreaMin && !!tenantInMarket.landAreaMax && `${formatNumber(tenantInMarket.landAreaMin)} - ${tenantInMarket.landAreaMax} Acres`}</div>
                </div>
                <div className={popupStyles.tableItem}>
                    <div>Building Area Needed</div>
                    <div>{!!tenantInMarket.buildingAreaMin && !!tenantInMarket.buildingAreaMax && `${formatNumber(tenantInMarket.buildingAreaMin)} - ${tenantInMarket.buildingAreaMax} Sq-Ft`}</div>
                </div>
            </div>
            <div className={popupStyles.body}>
                <FieldRow label="USE TYPE">
                    {tenantInMarket.useType}
                </FieldRow>
                <FieldRow label="CONTACT">
                    {tenantInMarket.contact}
                </FieldRow>
                <FieldRow label="TIMING">
                    {tenantInMarket.timing}
                </FieldRow>
                <div className={popupStyles.modified}>
                    <span>{tenantInMarket.modifiedByUser}</span><br /><span>{formatDateTime(tenantInMarket.modifiedDate)}</span>
                </div>
            </div>
        </MapPopupWithFitBounds>
    );
}

export default observer(TenantInMarketPopup);

interface ITenantInMarketPopupProps {
    id: number;
}
